import React from "react";
import styles from "../DressingChangeFrequency.module.scss";
import { PRESETS, getCounts, presetMatches } from "../utils/scheduleUtils";
import type { Schedule, SchedulePatch } from "../types";

interface QuickPicksPanelProps {
  schedule: Schedule;
  startDate: Date;
  onChange: (patch: SchedulePatch) => void;
}

export const QuickPicksPanel: React.FC<QuickPicksPanelProps> = ({
  schedule,
  startDate,
  onChange,
}) => (
  <div className={styles.panel_row}>
    <span className={styles.panel_label}>Quick picks</span>
    <div className={styles.quick_picks_grid}>
      {PRESETS.map((preset) => {
        const on = presetMatches(schedule, preset.patch);
        const previewSchedule: Schedule = { ...schedule, ...preset.patch };
        const dots = getCounts(previewSchedule, startDate)
          .slice(0, 7)
          .map((n, i) => {
            const dotClass =
              previewSchedule.mode === "prn"
                ? styles.preset_dot_dashed
                : n > 0
                ? on
                  ? styles.preset_dot_on
                  : styles.preset_dot_dim
                : styles.preset_dot_off;
            return <span key={i} className={`${styles.preset_dot} ${dotClass}`} />;
          });
        return (
          <button
            key={preset.label}
            type="button"
            className={`${styles.preset_tile} ${on ? styles.preset_tile_on : ""}`}
            aria-pressed={on}
            onClick={() => onChange(preset.patch)}
          >
            <span>{preset.label}</span>
            <span className={styles.preset_dots} aria-hidden="true">
              {dots}
            </span>
          </button>
        );
      })}
    </div>
  </div>
);
